<script lang="ts" setup>
  import { ref } from 'vue';
  import type { PlayerChoosingView } from '../../../../shared/api/round.ts';
  import GameHeader from '../GameHeader.vue';
  import GameSettingsContainer from '../lobby/GameSettingsContainer.vue';
  import SettingsModal from '../lobby/SettingsModal.vue';
  import Countdown from './Countdown.vue';
  import HostCountdownButton from './HostCountdownButton.vue';
  import HostPauseButtonContainer from './HostPauseButtonContainer.vue';

  type RoundHeaderView = Pick<
    PlayerChoosingView,
    'gameConfig' | 'paused' | 'phaseLengthsRange' | 'roundsRange' | 'standing'
  > & {
    round: Pick<PlayerChoosingView['round'], 'number'>;
  };

  defineProps<{ secondsLeft: string; view: RoundHeaderView; isHost: boolean }>();

  const showSettingsModal = ref(false);
</script>

<template>
  <GameHeader class="round-header" :standing="view.standing">
    <span class="round-number">{{ view.round.number }} / {{ view.gameConfig.rounds }}</span>
    <HostCountdownButton v-if="isHost" :seconds-left="secondsLeft" @click="showSettingsModal = true" />
    <Countdown v-else :seconds-left="secondsLeft" />
    <SettingsModal v-if="showSettingsModal" @close="showSettingsModal = false">
      <GameSettingsContainer
        :config="view.gameConfig"
        :phase-lengths-range="view.phaseLengthsRange"
        :rounds-range="view.roundsRange"
      />
      <HostPauseButtonContainer :paused="view.paused" @toggled="showSettingsModal = false" />
    </SettingsModal>
  </GameHeader>
</template>

<style scoped>
  .round-header {
    margin-bottom: 0.75rem;
  }

  .round-number {
    background: var(--color-surface);
    border: 2px solid var(--color-border-subtle);
    border-radius: var(--radius-full);
    bottom: 0;
    font-size: var(--font-size-sm);
    font-variant-numeric: tabular-nums;
    font-weight: var(--font-weight-strong);
    left: 50%;
    line-height: 1;
    padding: 0.25rem 0.75rem;
    position: absolute;
    transform: translate(-50%, 50%);
    white-space: nowrap;
  }
</style>
